import Vue from 'vue'
import VueResizeObserver from 'vue-resize-observer'

Vue.use(VueResizeObserver)
